<template>
<md-dialog :md-active.sync="active" :md-close-on-esc="false"
:md-click-outside-to-close="false" :class="{'custom-padding': padding}" :data-notif-id="values.notif_id">
    <md-progress-bar md-mode="indeterminate" v-if="isLoading"/>
    <template v-if="!isRefundFormShow">
      <md-dialog-title>{{ i18n.lbl_aml_title_large() }}</md-dialog-title>
      <detail v-if="values.status" :prop="i18n.lbl_status()" :bold="isShowStatus" :capitalize="true" :value="values.status"  :valueTextColor="isShowStatus ? 'red' : '$col-text'"/>
      <detail v-if="values.reason" :prop="i18n.lbl_reason()" :value="capitalizeReason" :valueTextColor="isShowStatus ? 'red' : '$col-text'"/>
      <detail v-if="values.timeStamp" :prop="i18n.lbl_time_optional()"  :value="values.timeStamp"/>
      <!-- <detail v-if="values.order_uuid" :prop="i18n.lbl_order_uid()"  :value="values.order_uuid" :copiable="true"/> -->
      <detail v-if="values.wallet" :prop="i18n.lbl_wallet()"  :value="values.wallet" :copiable="true"/>
      <detail v-if="values.hash" :prop="i18n.lbl_hash()"  :value="values.hash" :copiable="true"/>
      <detail v-if="values.asset" :prop="i18n.lbl_asset()"  :value="formatToken"/>
      <detail v-if="values.amount" :prop="i18n.lbl_amount()"  :value="amount"/>
      <detail v-if="values.order_no" :prop="i18n.lbl_order_id()"  :value="values.order_no" :copiable="true"/>
      <detail v-if="values.order_amount" :prop="i18n.lbl_order_amount()"  :value="orderAmount"/>
      <detail v-if="values.order_network" :prop="i18n.lbl_order_network()" :value="values.order_network"/>
      <detail v-if="values.error" :prop="i18n.lbl_reason()"  :value="values.error"/>
      <Aml v-if="amlValues && !isShowStatus" :score="riskScore" :values="amlValues" :higthRisk="higthRisks"/>
      <md-dialog-actions v-if="values.type === 2">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" v-if="isShowRefund" @click="getRefundStatus">{{ i18n.lbl_refund() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="deposit">{{ i18n.lbl_deposit_white() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="depositDirty">{{ i18n.lbl_credit_dirty() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="postpone">{{ i18n.lbl_put_aside() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>
      <md-dialog-actions v-if="values.type === 3">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="withdrawal">{{ i18n.lbl_deposit() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="cencelWithdrawal">{{ i18n.lbl_cancel() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>
      <md-dialog-actions v-if="values.type === -1">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" v-if="isShowRefund" @click="getRefundStatus">{{ i18n.lbl_refund() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="deposit">{{ i18n.lbl_deposit_white() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="depositDirty">{{ i18n.lbl_credit_dirty() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="checkAgaingDeposit">{{ i18n.lbl_check_again() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="postpone">{{ i18n.lbl_put_aside() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>
      <md-dialog-actions v-if="values.type === -2">
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="withdrawal">{{ i18n.lbl_deposit() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="cencelWithdrawal">{{ i18n.lbl_cancel() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default" :disabled="isLoading" @click="checkAgaingWithdrawal">{{ i18n.lbl_check_again() }}</md-button>
          <md-button class="md-button btn md-primary md-theme-default md-yellow" :disabled="isLoading" @click="checkManual">{{ i18n.lbl_check_crystal() }}</md-button>
      </md-dialog-actions>
      
      <p class="text-center error" v-if="error">{{ i18n.lbl_something_wrong() }}</p>
    </template>
    <template v-else>
      <RefundModal :token="formatToken" :isLoading="isLoading" :status="refundStatus" :values="values" @deleteNotif="deleteNotif" @refreshStatus="getRefundStatus" @close="toggleRefund" @setIsLoading="setIsLoading" @toggleError="toggleError"/>
    </template>
</md-dialog>
</template>

<script>
import Aml from '../app/history/index/components/Aml.vue'
import RefundModal from './RefundModal.vue'
import Detail from '@vue/app/common/Detail.Row'
import { vuexTypes } from '@vuex/types'
import { i18n } from '@js/i18n'
import { CRYPTO_CURRENCYS } from '@utils/consts'
import CurrencyRound from '@com/mixins/currency.round.mixin'
import { mapActions, mapGetters } from 'vuex'
import apiHelper from '@utils/cunstomInterseptor'

export default {
  name: 'AmlDialog',
  components: { Aml, Detail, RefundModal },
  mixins: [CurrencyRound],
  data () {
    return {
      i18n,
      isLoading: false,
      error: false,
      isRefundFormShow: false,
      refundStatus: null
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      required: true
    },
    account: {
      type: String,
      required: true
    },
    padding: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close'],
  methods: {
    ...mapActions({
      deleteNotificationById: 'deleteNotificationById'
    }),
    toggleRefund () {
      this.isRefundFormShow = !this.isRefundFormShow
    },
    toggleError (val) {
      this.error = val
    },
    async getRefundStatus () {
      try {
        this.error = false
        this.isLoading = true
        const { data } = await apiHelper.get(`/refund/status?wallet=${this.values.wallet}`)
        this.refundStatus = data
        this.refundStatus.refund_amount = this.roundCurrency2(Number(this.refundStatus.refund_amount) / 1000000, this.values.asset)
        this.refundStatus.refund_commission = this.roundCurrency2(Number(this.refundStatus.refund_commission) / 1000000, this.values.asset)
        this.refundStatus.source_balance = this.roundCurrency2(Number(this.refundStatus.source_balance) / 1000000, this.values.asset)
        if (this.refundStatus.auto_execute_at) {
          this.refundStatus.auto_execute_at = this.getTimeRemaining(this.refundStatus.auto_execute_at)
        }
        this.isRefundFormShow = true
      } catch (err) {
        this.error = true
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    setIsLoading (val) {
      this.isLoading = val
    },
    async cencelWithdrawal () {
      try {
        this.isLoading = true
        this.error = false
        let asset = this.values.asset === CRYPTO_CURRENCYS.USDTRC ? 2 : this.values.asset === CRYPTO_CURRENCYS.USDTERC ? 0 : 1
        const isType = (this.values.type === 3 || this.values.type === -2) || false
        const sendData = {network: asset}
        if (isType) {
          sendData.direction = this.values.tx_direction || this.values.TxDirection
          sendData.pending_withdrawal_id = this.values.id
          sendData.approval_level = 1
        }
        await apiHelper.put(`/cancel_pending_withdrawal`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async deleteNotif () {
      await this.deleteNotificationById(this.values)
      this.$emit('close')
    },
    async deposit () {
      try {
        this.isLoading = true
        this.error = false
        let asset = this.values.asset === CRYPTO_CURRENCYS.USDTRC ? 2 : this.values.asset === CRYPTO_CURRENCYS.USDTERC ? 0 : 1
        const sendData = {network: asset}
        sendData.direction = this.values.tx_direction || this.values.TxDirection
        sendData.pending_deposit_id = this.values.id
        await apiHelper.put(`/confirm_pending_deposit/clean`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async withdrawal () {
      try {
        this.isLoading = true
        this.error = false
        let asset = this.values.asset === CRYPTO_CURRENCYS.USDTRC ? 2 : this.values.asset === CRYPTO_CURRENCYS.USDTERC ? 0 : 1
        const sendData = {network: asset}
        sendData.direction = this.values.tx_direction || this.values.TxDirection
        sendData.pending_withdrawal_id = this.values.id
        sendData.approval_level = 1
        await apiHelper.put(`/confirm_pending_withdrawal`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async depositDirty () {
      try {
        this.isLoading = true
        this.error = false
        let asset = this.values.asset === CRYPTO_CURRENCYS.USDTRC ? 2 : this.values.asset === CRYPTO_CURRENCYS.USDTERC ? 0 : 1
        const sendData = {network: asset}
        sendData.direction = this.values.tx_direction || this.values.TxDirection
        sendData.pending_deposit_id = this.values.id
        await apiHelper.put(`/confirm_pending_deposit/dirty`, {
          ...sendData
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async checkAgaingDeposit () {
      try {
        this.isLoading = true
        this.error = false
        let asset = this.values.asset === CRYPTO_CURRENCYS.USDTRC ? 2 : this.values.asset === CRYPTO_CURRENCYS.USDTERC ? 0 : 1
        await apiHelper.post(`/aml_check_deposit_again`, {
          network: asset,
          pending_deposit_id: this.values.id
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async checkAgaingWithdrawal () {
      try {
        this.isLoading = true
        this.error = false
        let asset = this.values.asset === CRYPTO_CURRENCYS.USDTRC ? 2 : this.values.asset === CRYPTO_CURRENCYS.USDTERC ? 0 : 1
        await apiHelper.post(`/aml_check_withdrawal_again`, {
          network: asset,
          pending_withdrawal_id: this.values.id
        })
        await this.deleteNotificationById(this.values)
        this.isLoading = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async postpone () {
      try {
        this.isLoading = true
        this.error = false
        this.$emit('close')
      } catch (e) {
        this.error = true
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async checkManual () {
      try {
        this.isLoading = true
        let asset = this.values.asset === CRYPTO_CURRENCYS.USDTRC ? 2 : this.values.asset === CRYPTO_CURRENCYS.USDTERC ? 0 : 1
        await apiHelper.put(`/manual_aml_check_deposit`, {
          network: asset
        })
        if (this.values.type === 2) {
          window.open(`https://expert.crystalintelligence.com/trx/tx/${this.values.hash}?tab=internal`)
        } else if (this.values.type === 3) {
          window.open(`https://expert.crystalintelligence.com/trx/address/${this.values.wallet}?tab=connections`)
        } else if (this.values.type === -1) {
          window.open(`https://expert.crystalintelligence.com/trx/tx/${this.values.hash}?tab=internal`)
        } else if (this.values.type === -2) {
          window.open(`https://expert.crystalintelligence.com/trx/address/${this.values.wallet}?tab=connections`)
        }
        this.isLoading = false
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    getTimeRemaining (targetTimeStr) {
      let fixedStr = targetTimeStr
      const match = targetTimeStr.match(/T(\d{3,}):/)
      if (match) {
        const hour = parseInt(match[1], 10)
        fixedStr = targetTimeStr.replace(/T\d{3,}:/, `T${hour.toString().padStart(2, '0')}:`)
      }
      const now = new Date()
      const targetTime = new Date(fixedStr)

      if (isNaN(targetTime.getTime())) {
        throw new Error('Invalid date string after correction')
      }

      let diff = targetTime - now

      if (diff <= 0) {
        return { hours: 0, minutes: 0, seconds: 0 }
      }

      let seconds = Math.floor((diff / 1000) % 60)
      let minutes = Math.floor((diff / (1000 * 60)) % 60)
      let hours = Math.floor(diff / (1000 * 60 * 60))

      seconds = Number.isFinite(seconds) ? seconds : 0
      minutes = Number.isFinite(minutes) ? minutes : 0
      hours = Number.isFinite(hours) ? hours : 0

      return { hours, minutes, seconds }
    }
  },
  computed: {
    ...mapGetters([
      vuexTypes.userEmail
    ]),
    capitalizeReason () {
      if (this.values.reason) {
        let str = this.values.reason.trim()
        return str.charAt(0).toUpperCase() + str.slice(1)
      }
      return ''
    },
    isShowRefund () {
      return this.values.order_no
    },
    amount () {
      if (this.values.amount) {
        const num = this.values.asset === CRYPTO_CURRENCYS.USDTBEP ? Number(this.values.amount) / 1000000000000000000 : Number(this.values.amount) / 1000000
        return this.roundCurrency3(num, this.values.asset)
      }
    },
    orderAmount () {
      if (this.values.order_amount) {
        return `${this.roundCurrency3(this.values.order_amount)} ${this.values.order_currency}`
      }
      return false
    },
    isShowStatus () {
      if (this.values.status.toLowerCase() === 'failed') {
        return true
      }
      return false
    },
    formatToken () {
      let token = this.values.asset.startsWith('USDT') ? this.values.asset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') : this.values.asset
      return token
    },
    amlValues () {
      // eslint-disable-next-line
      if (this.values.fields) {
        let { riskscore, ...others } = this.values.fields
        return others
      }
      return null
    },
    riskScore () {
      if (this.values.fields && this.values.fields.riskscore) {
        return (Number(this.values.fields.riskscore) * 100).toFixed(1)
      }
      return null
    },
    higthRisks () {
      if (this.values.high_risk_fields) {
        return this.values.high_risk_fields
      }
      return []
    }
  }
}
</script>

<style scoped lang="scss">
.w-100 {
  width: 100%;
}
.custom-padding {
  padding-right: 56px !important;
}
.error {
  text-align: center;
  color: red;
}
.md-title {
    padding-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/vue/navigation/AmlDialog.vue